export { default } from './EyewearWarning';
